module.exports = __webpack_public_path__ + "static/img/3_2_5.f91461da.jpg";